import { render } from "./quotemensaje_ingles.vue?vue&type=template&id=2d15011b&scoped=true"
import script from "./quotemensaje_ingles.vue?vue&type=script&lang=js"
export * from "./quotemensaje_ingles.vue?vue&type=script&lang=js"

import "./quotemensaje_ingles.vue?vue&type=style&index=0&id=2d15011b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d15011b"]])

export default __exports__